export const categoryKeywords = {
    Food: ['supermarket', 'restaurant', 'food', 'dinner', 'lunch', 'groceries'],
    Transportation: ['taxi', 'bus', 'metro', 'train', 'bike', 'uber', 'lyft'],
    Housing: ['rent', 'mortgage', 'electricity', 'water', 'internet', 'utilities'],
    Entertainment: ['cinema', 'theater', 'concert', 'book', 'videogames', 'movies'],
    Health: ['pharmacy', 'medicine', 'doctor', 'hospital', 'clinic', 'gym'],
    Education: ['tuition', 'courses', 'books', 'training'],
    Clothing: ['clothes', 'shoes', 'apparel', 'uniform'],
    'Gifts and Donations': ['gift', 'donation', 'charity', 'present'],
    Travel: ['flight', 'hotel', 'car rental', 'travel', 'vacation'],
    'Other Expenses': ['miscellaneous', 'other expenses', 'other'],
};
